import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation UpdateAllowedDomains($allowedDomains: [AllowedDomainInput!]) {
  updateAllowedDomains(allowedDomains: $allowedDomains)
}`;

function parseDomains(allowedDomains) {
  return allowedDomains.map((item) => {
    const itemR = {
      ...item,
    };
    Object.keys(itemR).forEach((key) => {
      if (key === '__typename') {
        delete itemR[key];
      }
    });
    return itemR;
  });
}

function updateAllowedDomains(allowedDomains) {
  return apollo.client.mutate({
    variables: {
      allowedDomains: parseDomains(allowedDomains),
    },
    mutation,
  }).then((res) => res.data);
}

export default updateAllowedDomains;
